/** Bars the live meter is drawn with. */
export const kVoiceBars = 14;

/**
 * A live level (peak amplitude, 0 to 1) as a bar's height: by loudness in
 * decibels, -50 dB empty to 0 dB full, so speech moves it at any volume.
 */
export function meterLevel(level: number): number {
  if (level <= 0) return 0;
  return Math.min(1, Math.max(0, (20 * Math.log10(level) + 50) / 50));
}
